<!--
 * @Author: zhangyu
 * @Date: 2021-12-27 14:22:37
 * @LastEditors: 汪俊洪
 * @LastEditTime: 2025-07-31 16:00:00
 * @Description: 领用备件编辑页面
-->
<template>
  <div class="home_page">
    <div class="spare_add_page">
      <!-- 面包屑组件 -->
      <Breadcrumb :pageTitle="pageTitle" />
      <div class="page_detail">
        <h2>{{ $t("route.requisitionOrderUpdate") }}</h2>
        <!-- 步骤条 -->
        <ProgressBar
          style="width: 100%"
          :progressList="steps"
          barTitle=""
          themeColor="blue"
        />
        <el-form
          :model="detailInfo"
          ref="detailInfoform"
          :rules="detailInfoRule"
          label-width="130px"
          label-position="right"
        >
          <div class="base_info box_distance">
            <h2>{{ $t("account.basicInfo") }}</h2>
            <el-row>
              <el-col>
                <el-form-item :label="`${$t('stockNeed.orderNo1')}：`">
                  {{ detailInfo.orderCode }}
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :label="`${$t('header.companyName')}：`">
                  {{ $store.state.user.company.companyName }}
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item :label="`${$t('stockNeed.requestTime2')}：`">
                  <label>
                    <el-date-picker
                      v-model="detailInfo.createTime"
                      type="date"
                      :disabled="true"
                      :placeholder="$t('message.select')"
                    >
                    </el-date-picker>
                  </label>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item
                  :label="`${$t('stockNeed.requestDelieveryTime')}：`"
                  prop="expectDeliveryDate"
                >
                  <el-date-picker
                    v-model="detailInfo.expectDeliveryDate"
                    type="date"
                    :placeholder="$t('message.select')"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    clearable
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item
                  :label="`${$t('stockNeed.comment')}：`"
                  prop="orderRemarks"
                >
                  <el-input
                    type="textarea"
                    maxlength="200"
                    v-model="detailInfo.orderRemarks"
                    :placeholder="$t('stockNeed.limitTwoHundred2')"
                    style="width: 600px !important"
                    :rows="3"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item
                  :label="`${$t('orderlist.customerNo')}：`"
                  prop="custOrderNo"
                >
                  <el-input
                    maxlength="200"
                    v-model="detailInfo.custOrderNo"
                    :placeholder="$t('message.select')"
                    style="width: 600px !important"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item
                  :label="$t('orderlist.attachment') + '：'"
                  prop="attachmentList"
                >
                  <Upload
                    :buttonText="$t('stockNeed.uploadFile')"
                    :tip="$t('stockNeed.uploadFileNote20')"
                    :limit="20"
                    :action="action"
                    :fileList="orderFileList"
                    @onSuccess="getFileList"
                  ></Upload>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <div class="address_info box_distance">
            <h2>
              {{ $t("order.address") }}
              <div class="addBtn-box" @click="modifyAddress">
                {{ $t("order.updateAddress") }}
              </div>
            </h2>
            <el-form-item v-if="detailInfo.addressVo" label-width="0">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item :label="`${$t('order.recipient')}:`">
                    {{ detailInfo.addressVo.receiveGoodsPerson }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="`${$t('stockNeed.phone')}:`">
                    {{ detailInfo.addressVo.receiveGoodsPhone }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item :label="`${$t('order.detailAddress')}:`">
                    {{ detailInfo.addressVo.province }}
                    {{ detailInfo.addressVo.city }}
                    {{ detailInfo.addressVo.area }}
                    {{ detailInfo.addressVo.address }}
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>
          </div>
          <div class="invoice_info box_distance">
            <h2>
              发票信息
              <div class="addBtn-box" @click="invoiceModifyHandle">
                修改发票
              </div>
            </h2>
            <el-form-item v-if="detailInfo.payOrderInvoiceVo" label-width="0">
              <el-row :gutter="20">
                <el-col>
                  <el-form-item label="发票类型:">
                    <span v-if="detailInfo.payOrderInvoiceVo.invoiceType">
                      增值税{{
                        detailInfo.payOrderInvoiceVo.invoiceType === "10"
                          ? "普通发票"
                          : "专用发票"
                      }}
                    </span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="发票抬头:">
                    {{ detailInfo.payOrderInvoiceVo.companyName }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="税号:">
                    {{ detailInfo.payOrderInvoiceVo.taxpayerIdentity }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="开户行:">
                    {{ detailInfo.payOrderInvoiceVo.openingBank }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="账户:">
                    {{ detailInfo.payOrderInvoiceVo.bankAccountNo }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="地址:">
                    {{ detailInfo.payOrderInvoiceVo.companyAddress }}
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="电话:">
                    {{ detailInfo.payOrderInvoiceVo.companyPhone }}
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>
          </div>
          <div class="produce_info box_distance">
            <h2>{{ $t("stockNeed.items") }}</h2>
            <div>
              <el-button
                type="primary"
                style="background: #3d88d4; color: #fff; border-color: #3d88d4"
                @click="addNew()"
              >
                {{ $t("stockNeed.addItems") }}
              </el-button>
              <el-button
                type="primary"
                style="background: #3d88d4; color: #fff; border-color: #3d88d4"
                @click="importInfo()"
              >
                {{ $t("stockNeed.stockUpload") }}
              </el-button>
              <el-upload
                v-show="false"
                ref="fielUplod"
                :on-success="fileSuccess"
                :on-error="fileError"
                accept="csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                :headers="headerMsg"
                :action="upLoadUrl"
              >
                <el-button type="primary">{{ $t("oss.upload") }}</el-button>
              </el-upload>
              <el-button
                style="margin-left: 10px"
                type="text"
                @click="downloadTemplate('17')"
              >
                {{ $t("stockNeed.downloadTemp2") }}
              </el-button>
              <el-button
                style="margin-left: 10px"
                type="text"
                @click="downloadTemplate('23')"
              >
                {{ $t("stockNeed.downloadTemp3") }}
              </el-button>
            </div>
            <el-form-item label-width="0" prop="receiveDetailList">
              <div
                style="
                  border: 1px solid #ddd;
                  border-bottom: none;
                  margin-top: 10px;
                "
              >
                <el-table
                  ref="goodsTable"
                  size="small"
                  :data="detailInfo.receiveDetailList"
                  :header-cell-style="{ background: '#f9f9f9' }"
                  style="width: 100%"
                >
                  <el-table-column
                    type="index"
                    width="50"
                    :label="$t('product.id')"
                  ></el-table-column>
                  <el-table-column
                    prop="oldGoodsCode"
                    header-align="center"
                    align="center"
                    :label="$t('product.codes')"
                    width="150"
                    class="goodsCode"
                  >
                    <template slot-scope="scope">
                      <el-form-item
                        :prop="
                          'receiveDetailList.' + scope.$index + '.oldGoodsCode'
                        "
                        :rules="detailInfoRule['oldGoodsCode']"
                      >
                        <el-autocomplete
                          :minlength="2"
                          v-model.trim="scope.row.oldGoodsCode"
                          :fetch-suggestions="querySearchAsync"
                          :placeholder="$t('evaluate.placeholder')"
                          @input="(e) => handleChange(e, scope, scope.$index)"
                          @select="handleSelect($event, scope.$index)"
                          style="width: 105px !important"
                          popper-class="my-kqoption-spareGetAdd"
                          :maxlength="20"
                        ></el-autocomplete>
                      </el-form-item>

                      <i
                        style="position: absolute; right: 10px; top: 20px"
                        v-if="!scope.row.custspId && !scope.row.oldGoodsCode"
                        class="el-icon-search"
                        @click="openDialogHandle(scope.row, scope.$index)"
                      ></i>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="oldGoodsName"
                    header-align="center"
                    align="center"
                    :label="$t('ordervote.productName')"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    min-width="95"
                    prop="oldSpecification"
                    header-align="center"
                    align="center"
                    :label="$t('common.specification')"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="oldModel"
                    header-align="center"
                    align="center"
                    :label="$t('common.model')"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="brandName"
                    header-align="center"
                    align="center"
                    :label="$t('common.brand')"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="sellingUnit"
                    header-align="center"
                    align="center"
                    :label="`${$t('cart.column3')}/${$t('cart.column4')}`"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      {{ scope.row.goodsPrice | formatePrice4 }}/{{ scope.row.sellingUnit || '-' }}
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="oldRemark"
                    header-align="center"
                    align="center"
                    :label="$t('dict.remark')"
                    width="200px"
                  >
                    <template slot-scope="scope">
                      <el-input
                        type="textarea"
                        :placeholder="$t('stockNeed.enterRemark')"
                        v-model="scope.row.oldRemark"
                        clearable
                        maxlength="300"
                        :rows="2"
                        resize="none"
                      ></el-input>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="safetyStockQuantity"
                    header-align="center"
                    align="center"
                    label="备件数量"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop="goodsNum"
                    header-align="center"
                    align="center"
                    :label="$t('stockNeed.getAmount')"
                    width="120px"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <el-form-item
                        :prop="
                          'receiveDetailList.' + scope.$index + '.goodsNum'
                        "
                        :rules="detailInfoRule['goodsNum']"
                      >
                        <el-tooltip
                          placement="top"
                          :content="`起订量${scope.row.moq || 1}, 步长${
                            scope.row.sellingUnitStepSize || 1
                          }`"
                        >
                          <span>
                            <el-input-number
                              style="width: 100px"
                              controls-position="right"
                              v-model="scope.row.goodsNum"
                              :precision="0"
                              :min="1"
                              :max="999999999"
                              :step="scope.row.sellingUnitStepSize || 1"
                              @change="
                                (currentValue, oldValue) =>
                                  changeAmount(
                                    currentValue,
                                    oldValue,
                                    scope.row,
                                    scope.$index
                                  )
                              "
                            ></el-input-number>
                          </span>
                        </el-tooltip>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column
                    fixed="right"
                    header-align="center"
                    align="center"
                    :label="$t('handle')"
                    width="60px"
                  >
                    <template slot-scope="scope">
                      <el-button
                        type="text"
                        size="small"
                        @click="deleteHandle(scope.row, scope.$index)"
                        >{{ $t("delete") }}</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </el-form-item>
          </div>
          <div class="total_info box_distance">
            <div
              v-if="
                detailInfo.excessMemo !== null && detailInfo.excessMemo !== ''
              "
              style="display: inline-block; margin-top: 15px; margin-left: 15px"
            >
              <el-form
                :model="dataForm"
                :inline="true"
                ref="dataForm"
                label-position="left"
                class="demo-form-inline"
              >
                <el-form-item
                  :label="$t('stockNeed.exceedHolder')"
                  prop="excessMemo"
                >
                  <label>
                    <el-input
                      type="textarea"
                      maxlength="200"
                      :placeholder="$t('stockNeed.exceedReasonHolder')"
                      v-model.trim="detailInfo.excessMemo"
                      style="width: 460px !important"
                      :rows="2"
                    ></el-input>
                  </label>
                </el-form-item>
              </el-form>
            </div>
            <div
              style="display: inline-block; position: absolute; right: 200px"
            >
              <p class="total_produce">
                {{ $t("stockNeed.total1") }}{{ produceTypeNum }}
                {{ $t("stockNeed.total2") }} {{ produceNum }}
                {{ $t("stockNeed.total3") }}
              </p>
              <p class="total_price">
                {{ $t("stockNeed.totalPrice") }}：<span class="price"
                  >{{ $t("common.currency") }}{{ price | formatePrice4 }}</span
                >
              </p>
            </div>
            <div @click="handleSave()" class="submit_btn">
              {{ $t("stockNeed.submitbtn") }}
            </div>
          </div>
        </el-form>
      </div>
    </div>
    <!-- 备件选择 -->
    <el-dialog
      :visible.sync="searchVisible"
      :close-on-click-modal="false"
      :before-close="cancelGoods"
      :title="$t('stockNeed.chooseSpare')"
      width="1200px"
      class="produce_dialog"
    >
      <SearchGoods
        v-if="searchVisible"
        :dataList="detailInfo.receiveDetailList"
        @selected="confirmPush"
        @close="searchVisible = false"
        :companyId="companyId"
      />
    </el-dialog>
    <!-- 批量导入失败原由 -->
    <el-dialog
      title="批量导入失败原由"
      :close-on-click-modal="false"
      :visible.sync="importVisible"
      width="530px"
    >
      <div v-html="errorContent"></div>
      <span slot="footer">
        <div class="addFunc">
          <el-button
            style="background-color: #3d88d4; border: 0"
            type="primary"
            @click="handleExportFailed()"
            >查看失败信息</el-button
          >
        </div>
      </span>
    </el-dialog>
    <!-- 失败记录弹窗 -->
    <el-dialog
      :visible.sync="exportVisible"
      :close-on-click-modal="false"
      :before-close="cancelFail"
      title="失败记录"
      width="990px"
    >
      <el-form
        :model="dataForm3"
        :inline="true"
        ref="dataForm2"
        class="demo-form-inline"
        label-width="160px"
      >
        <el-row style="float: right; margin-bottom: 10px">
          <el-button
            style="background-color: #3d88d4; border: 0"
            type="primary"
            @click="handleFailExport()"
            >导出</el-button
          >
        </el-row>
        <el-table
          :data="dataFailedList"
          border
          v-loading="dataListLoading"
          style="width: 100%"
        >
          <el-table-column
            type="index"
            label="序号"
            width="50"
          ></el-table-column>
          <el-table-column
            prop="oldGoodsCode"
            header-align="center"
            align="left"
            width="150"
            label="物品编码"
          >
          </el-table-column>
          <el-table-column
            prop="oldSpecification"
            header-align="center"
            align="left"
            label="规格"
          >
          </el-table-column>
          <el-table-column
            prop="oldModel"
            header-align="center"
            align="left"
            label="型号"
          >
          </el-table-column>
          <el-table-column
            prop="goodsCode"
            header-align="center"
            align="left"
            label="平台物料编码"
          >
          </el-table-column>
          <el-table-column
            prop="goodsNum"
            header-align="center"
            align="center"
            label="领用数量"
          >
          </el-table-column>
          <el-table-column
            prop="msg"
            header-align="center"
            align="center"
            label="失败原因"
          >
          </el-table-column>
        </el-table>
        <el-pagination
          background
          style="margin-top: 10px; text-align: center"
          layout="prev, pager, next, total, jumper"
          prev-text="上一页"
          next-text="下一页"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-size="10"
          :pager-count="5"
          :total="total"
        ></el-pagination>
      </el-form>
      <div class="addFunc">
        <el-button
          style="background-color: #3d88d4; border: 0; width: 96px"
          type="primary"
          @click="cancelFail"
          >取消</el-button
        >
      </div>
    </el-dialog>
    <!-- 领用超量原因弹窗 -->
    <el-dialog
      :visible.sync="visible"
      :close-on-click-modal="false"
      :before-close="cancelAdd"
      :title="$t('stockNeed.exceedTitle')"
      width="800px"
    >
      <el-form
        :model="dataForm"
        :inline="true"
        ref="dataForm"
        label-position="top"
        class="demo-form-inline"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item
              :label="$t('stockNeed.exceedHolder')"
              prop="excessMemo"
            >
              <label>
                <el-input
                  type="textarea"
                  maxlength="200"
                  :placeholder="$t('stockNeed.exceedReasonHolder')"
                  v-model.trim="detailInfo.excessMemo"
                  style="width: 760px !important"
                  :rows="3"
                ></el-input>
              </label>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="addFunc">
          <el-button
            style="background-color: #3d88d4; border: 0; width: 96px"
            type="primary"
            @click="handleSaveReason()"
            :class="subLoading ? 'but-loading' : ''"
            >{{ $t("confirm") }}</el-button
          >
          <el-button
            style="background-color: #fff; color: #3d88d4; width: 96px"
            type="primary"
            @click="cancelAdd()"
            >{{ $t("cancel") }}</el-button
          >
        </div>
      </el-form>
    </el-dialog>
    <!-- 收货地址信息编辑 -->
    <EditAddressDialog
      :editAddressVisible="editAddressVisible"
      :editAddressInfo="editAddressInfo"
      :buttonLoading="buttonLoading"
      @handleClose2="handleClose2"
      @handleAddressSaved="handleAddressSaved"
    />
    <!-- 编辑发票信息弹窗 -->
    <EditBillDialog
      :invoiceVisible="invoiceVisible"
      :invoiceForm="invoiceForm"
      :buttonLoading="buttonLoading"
      @closeInviceHandle="closeInviceHandle"
      @invoiceSaveHandle="invoiceSaveHandle"
    />
    <ErrorTip ref="errorTip"></ErrorTip>
  </div>
</template>
<script>
import Breadcrumb from '@/components/breadcrumb/index'
import ProgressBar from '../components/progressBar.vue'
import EditAddressDialog from '../components/editAddressDialog'
import EditBillDialog from '../components/editBillDialog'
import SearchGoods from '../../order/components/searchGoods'
import Upload from '@/components/upload/file'
// import debounce from 'lodash/debounce'
import { getAccessToken } from '@/utils/userInfo'
import axios from 'axios'
import { fomatDateTime } from '@/utils'
import ErrorTip from '../components/errorTip.vue'

export default {
  components: {
    Breadcrumb,
    ProgressBar,
    EditAddressDialog,
    EditBillDialog,
    Upload,
    ErrorTip,
    SearchGoods
  },
  data () {
    const validateGoodsNum = (rule, value, callback) => {
      const temp = Number(value)
      if (isNaN(temp)) {
        callback(new Error('请输入正确的领用数量'))
      } else if (temp === 0) {
        callback(new Error('领用数量不能为0'))
      } else {
        callback()
      }
    }
    return {
      orderFileList: [],
      action: window.SITE_CONFIG['apiURL'] + '/front/fileupload/alioss/upload',
      changeAble: false,
      buttonLoading: false, // 加载中
      showAddressVisible: true,
      moreInvoiceVisible: true,
      invoiceVisible: false, // 发票弹窗
      invoiceForm: {}, // 发票信息
      editAddressInfo: {}, // 编辑地址信息
      editAddressVisible: false, // 编辑地址弹窗
      addressDeleteId: null, // 删除地址ID
      addressDeleteVisible: false, // 删除地址确认弹窗
      searchVisible: false, // 物料列表弹窗
      // 面包屑
      pageTitle: [
        {
          label: this.$t('header.homepage'),
          url: '/'
        },
        {
          label: this.$t('header.storeSpare'),
          url: '/storeSpare'
        },
        {
          label: this.$t('header.spareOrder'),
          url: '/spareGetList'
        },
        {
          label: this.$t('route.requisitionOrderUpdate')
        }
      ],
      steps: [
        { title: this.$t('stockNeed.submit3'), status: 'finished' },
        { title: this.$t('applystatus.waiting'), status: 'current' },
        { title: this.$t('stockNeed.tabs5'), status: 'unfinished' },
        { title: this.$t('stockNeed.tabs6'), status: 'unfinished' },
        { title: this.$t('applystatus.beComplete'), status: 'unfinished' }
      ], // 进度条状态数组
      active: 0, // 进度条当前活动情况
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24
        }
      },
      detailInfo: {
        companyId: '',
        expectDeliveryDate: null, // 要求到货时间
        orderRemarks: null, // 备注
        orderInvoiceId: '', // 发票Id
        addressId: null, // 地址Id
        expedited: '', // 是否加急
        excessMemo: '', // 领用超量原因
        receiveDetailList: [], // 备件列表
        custOrderNo: '', // 客户单号
        orderInvoiceRefactoryForm: {},
        payOrderInvoiceVo: {},
        attachmentList: [] // 附件列表
      },
      detailInfoRule: {
        expectDeliveryDate: [
          {
            required: true,
            message: this.$t('message.emptyDate'),
            trigger: 'change'
          }
        ],
        addressId: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change'
          }
        ],
        receiveDetailList: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change'
          }
        ],
        oldGoodsCode: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change'
          }
        ],
        goodsNum: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change'
          },
          { validator: validateGoodsNum, trigger: 'change' }
        ]
      },
      detailListInfoform: {
        oldGoodsCode: [
          {
            required: true,
            message: this.$t('validate.required'),
            trigger: 'change'
          }
        ]
      },
      addressList: [], // 地址列表
      payInvoiceInfoList: [], // 发票列表
      goodsList: [], // 物料信息列表
      currentIndex: '',
      dataForm2: {
        specification: '',
        edition: '',
        goodsName: '',
        custGoodsCode: '', // 用户物品编码
        model: '' // 型号
      },
      dataListLoading: false,
      headerMsg: { Authorization: 'Bearer ' + getAccessToken() },
      upLoadUrl: '',
      importVisible: false, // 导入弹框
      exportVisible: false,
      errorContent: '',
      currentPage: 1,
      total: 0,
      pageSize: 10,
      dataFailedList: [],
      dataForm3: {
        customerCode: ''
      },
      subLoading: false,
      oweFeeFlag: '',
      visible: false, // 超量原因填写弹窗
      // 超量原因信息
      dataForm: {
        id: '',
        dateValue: '',
        expedited: 1,
        name: '',
        remarks: '',
        expectDeliveryDate: ''
      }
    }
  },
  computed: {
    companyId () {
      return this.$store.state.user.defaultCompanyId
    },
    produceTypeNum () {
      if (this.detailInfo.receiveDetailList) {
        return this.detailInfo.receiveDetailList.length
      }
      return 0
    },
    produceNum () {
      let res = 0
      if (this.detailInfo.receiveDetailList) {
        this.detailInfo.receiveDetailList.forEach((item) => {
          if (!isNaN(Number(item.goodsNum))) {
            res += Number(item.goodsNum)
          }
        })
      }
      if (isNaN(res)) {
        return 0
      } else {
        return res
      }
    },
    price () {
      let res = 0
      if (this.detailInfo.receiveDetailList) {
        this.detailInfo.receiveDetailList.forEach((item) => {
          if (item.goodsNum && item.goodsPrice) {
            let tempPrice = Number(item.goodsPrice) * Number(item.goodsNum)
            if (!isNaN(tempPrice)) {
              res += tempPrice
            }
          }
        })
      }
      if (isNaN(res)) {
        return 0
      } else {
        return res
      }
    }
  },
  watch: {
    detailInfo: {
      handler (newQuestion, oldQuestion) {
        let falg = true
        // console.log(newQuestion)
        newQuestion.receiveDetailList.forEach((item, index) => {
          if (
            item.safetyStockQuantity &&
            item.goodsNum > item.safetyStockQuantity
          ) {
            falg = false
          }
        })
        if (falg && this.detailInfo.excessMemo) {
          this.detailInfo.excessMemo = ''
        }
      },
      deep: true
    }
  },
  methods: {
    getFileList (fileList) {
      this.detailInfo.attachmentList = fileList
    },
    // 修改步长
    changeAmount (currentValue, oldValue, val, index) {
      // console.log(currentValue, oldValue, val, index);
      const value = this.detailInfo.receiveDetailList[index]
      // !value.sellingUnitStepSize && (value.sellingUnitStepSize = 8);
      if (
        value.sellingUnitStepSize &&
        currentValue % value.sellingUnitStepSize !== 0
      ) {
        const num =
          currentValue > oldValue && currentValue >= value.sellingUnitStepSize
            ? -(currentValue % value.sellingUnitStepSize)
            : value.sellingUnitStepSize -
              (currentValue % value.sellingUnitStepSize)
        if (num !== 0) {
          this.$nextTick(() => {
            this.$set(
              this.detailInfo.receiveDetailList[index],
              'goodsNum',
              currentValue + num
            )
          })
        }
      }
    },
    // 编辑地址
    modifyAddress () {
      this.editAddressInfo = {
        orderAddressId: this.detailInfo.addressVo.orderAddressId,
        companyId: this.detailInfo.addressVo.companyId, // 当前地址对应的公司Id
        userAddressId: this.detailInfo.addressVo.userAddressId,
        proCityArea: [],
        address: this.detailInfo.addressVo.address, // 地址
        orderAddress: '', // 省市区详细地址拼接
        province: '',
        city: '',
        area: '',
        receiveGoodsPerson: this.detailInfo.addressVo.receiveGoodsPerson, // 收货人
        receiveGoodsPhone: this.detailInfo.addressVo.receiveGoodsPhone, // 收货联系电话
        defaultAddress: this.detailInfo.addressVo.defaultAddress, // 是否默认地址
        used: this.detailInfo.addressVo.used // 是否可用
      }
      if (this.detailInfo.addressVo.province) {
        this.editAddressInfo.proCityArea.push(
          this.detailInfo.addressVo.province
        )
        if (this.detailInfo.addressVo.city) {
          this.editAddressInfo.proCityArea.push(this.detailInfo.addressVo.city)
          if (this.detailInfo.addressVo.area) {
            this.editAddressInfo.proCityArea.push(
              this.detailInfo.addressVo.area
            )
          }
        }
      }
      this.editAddressVisible = true
    },
    // 关闭弹窗  地址
    handleClose2 () {
      this.editAddressVisible = false
      this.editAddressInfo = {
        companyId: '', // 当前地址对应的公司Id
        userAddressId: '',
        proCityArea: [],
        address: '', // 地址
        orderAddress: '', // 省市区详细地址拼接
        province: '',
        city: '',
        area: '',
        receiveGoodsPerson: '', // 收货人
        receiveGoodsPhone: '', // 收货联系电话
        defaultAddress: false, // 是否默认地址
        used: true // 是否可用
      }
    },
    // 保存收货地址
    handleAddressSaved () {
      this.detailInfo.addressVo = this.editAddressInfo
      this.detailInfo.addressVo.province = this.editAddressInfo.proCityArea[0]
      this.detailInfo.addressVo.city = this.editAddressInfo.proCityArea[1]
      this.detailInfo.addressVo.area = this.editAddressInfo.proCityArea[2]
      this.handleClose2()
    },
    // 编辑发票
    invoiceModifyHandle () {
      this.invoiceVisible = true
      this.invoiceForm = {
        orderInvoiceId: this.detailInfo.payOrderInvoiceVo.orderInvoiceId,
        flagAdd: this.detailInfo.payOrderInvoiceVo.defaultFlag === '1',
        invoiceId: this.detailInfo.payOrderInvoiceVo.invoiceId,
        invoiceObjType: this.detailInfo.payOrderInvoiceVo.invoiceObjType, // 开票对象类型 10 个人 20 单位
        invoiceObjId: this.detailInfo.payOrderInvoiceVo.invoiceObjId, // 开票对象10 用户id 20 公司id
        invoiceType: this.detailInfo.payOrderInvoiceVo.invoiceType, // 开票类型10 普通发票 20 增值税发票
        companyName: this.detailInfo.payOrderInvoiceVo.companyName, // 开票公司名称(发票抬头)
        taxpayerIdentity: this.detailInfo.payOrderInvoiceVo.taxpayerIdentity, // 纳税人识别号
        companyAddress: this.detailInfo.payOrderInvoiceVo.companyAddress, // 公司地址
        companyPhone: this.detailInfo.payOrderInvoiceVo.companyPhone, // 联系电话
        openingBank: this.detailInfo.payOrderInvoiceVo.openingBank, // 开户行
        bankAccountNo: this.detailInfo.payOrderInvoiceVo.bankAccountNo, // 开户行账号
        defaultFlag: this.detailInfo.payOrderInvoiceVo.defaultFlag, //  默认发票标识
        remarks: this.detailInfo.payOrderInvoiceVo.remarks,
        mailingAddress: this.detailInfo.payOrderInvoiceVo.mailingAddress, // 发票邮寄地址
        consignee: this.detailInfo.payOrderInvoiceVo.consignee, // 收货人
        contactInformation:
          this.detailInfo.payOrderInvoiceVo.contactInformation // 收货人联系方式
      }
    },
    // 关闭发票
    closeInviceHandle () {
      this.invoiceVisible = false
      this.invoiceForm = {}
      // this.$refs['invoiceForm'].resetFields()
    },
    // 保存发票
    invoiceSaveHandle () {
      this.detailInfo.payOrderInvoiceVo = this.invoiceForm
      this.closeInviceHandle()
    },
    // 模板下载
    downloadTemplate (t) {
      const url = this.$getDictLabel('OMS_EXCELL_IMPORT_TYPE', t)
      console.log(url)
      if (!url || url === t) {
        this.$message.error('模板未配置，请联系管理员')
        return
      }
      window.location.href = url
    },
    // 手工增行
    addNew () {
      // 判断最后一条是否选择过
      if (
        this.detailInfo.receiveDetailList.length > 0 &&
        !this.detailInfo.receiveDetailList[
          this.detailInfo.receiveDetailList.length - 1
        ].oldGoodsCode
      ) {
        return
      }
      this.detailInfo.receiveDetailList.push({
        oldGoodsCode: '',
        oldGoodsName: '',
        oldSpecification: '',
        oldModel: '',
        oldRemark: '',
        goodsNum: '',
        oldEdition: '',
        oldConfiguration: '',
        safetyStockQuantity: '',
        goodsPrice: '',
        brandName: '',
        physicalUnitAmount: '',
        moq: '',
        sellingUnitStepSize: '',
        skuId: ''
      })
    },
    // 删行
    deleteHandle (row, index) {
      this.detailInfo.receiveDetailList.splice(index, 1)
    },
    // 远程搜索
    querySearchAsync (queryString, cb) {
      var array = []
      if (queryString && queryString.length > 1) {
        let params = {
          likeFlag: '1',
          oldGoodsCode: queryString,
          companyId: this.companyId
        }
        this.$http
          .post(`/front/order/lclb/receive/getGoodsByOrdinary`, params)
          .then(({ data: res }) => {
            if (res.code === 0) {
              if (res.data && res.data.length > 0) {
                res.data.forEach((item) => {
                  item.value = item.codeSpeciModel
                })
                cb(res.data)
              } else {
                cb(array)
              }
            } else {
              cb(array)
            }
          })
      } else {
        cb(array)
      }
    },
    handleChange (ind, a, index) {
      // const temp = this.detailInfo.receiveDetailList[index]
      // Object.getOwnPropertyNames(
      //   temp
      // ).forEach(function (key) {
      //   console.log(key, temp[key])
      //   temp[key] = ''
      // })
      // this.detailInfo.receiveDetailList[index] = temp
      this.detailInfo.receiveDetailList[index].oldConfiguration = ''
      this.detailInfo.receiveDetailList[index].oldEdition = ''
      this.detailInfo.receiveDetailList[index].oldGoodsName = ''
      this.detailInfo.receiveDetailList[index].oldModel = ''
      this.detailInfo.receiveDetailList[index].oldRemark = ''
      this.detailInfo.receiveDetailList[index].oldSpecification = ''
      this.detailInfo.receiveDetailList[index].brandName = ''
      this.detailInfo.receiveDetailList[index].safetyStockQuantity = ''
      this.detailInfo.receiveDetailList[index].goodsPrice = ''
      this.detailInfo.receiveDetailList[index].physicalUnitAmount = ''
      this.detailInfo.receiveDetailList[index].moq = ''
      this.detailInfo.receiveDetailList[index].sellingUnitStepSize = ''
      this.detailInfo.receiveDetailList[index].goodsNum = 1
      // console.log(this.detailInfo.receiveDetailList)
    },
    handleSelect (item, index) {
      const res = this.detailInfo.receiveDetailList.some((row, i) => {
        if (row.custspId === item.custspId && index !== i) {
          this.detailInfo.receiveDetailList[index].oldGoodsCode = ''
          this.$message.error(this.$t('message.sameSpare', { line: i + 1 }))
          return true
        }
        return false
      })
      if (res) {
        return
      }
      this.detailInfo.receiveDetailList[index].oldConfiguration =
        item.oldConfiguration
      this.detailInfo.receiveDetailList[index].oldEdition = item.oldEdition
      this.detailInfo.receiveDetailList[index].oldGoodsCode = item.oldGoodsCode
      this.detailInfo.receiveDetailList[index].oldGoodsName = item.oldGoodsName
      this.detailInfo.receiveDetailList[index].oldModel = item.oldModel
      this.detailInfo.receiveDetailList[index].oldRemark = item.oldRemark
      this.detailInfo.receiveDetailList[index].oldSpecification =
        item.oldSpecification
      this.detailInfo.receiveDetailList[index].brandName = item.brandName
      this.detailInfo.receiveDetailList[index].goodsPrice = item.price
      this.detailInfo.receiveDetailList[index].safetyStockQuantity =
        item.safetyStockQuantity
      this.detailInfo.receiveDetailList[index].custspId = item.custspId
      this.detailInfo.receiveDetailList[index].physicalUnitAmount =
        item.physicalUnitAmount
      this.detailInfo.receiveDetailList[index].moq = item.moq
      this.detailInfo.receiveDetailList[index].sellingUnitStepSize =
        item.sellingUnitStepSize
    },
    // 打开物料信息弹窗
    openDialogHandle (row, index) {
      this.dataForm2.specification = ''
      this.dataForm2.edition = ''
      this.dataForm2.configuration = []
      this.dataForm2.goodsName = ''
      this.goodsList = []
      this.currentIndex = index
      this.searchVisible = true
      this.handleCode()
    },
    // 查询物料信息
    handleCode () {
      this.dataListLoading = true
      let params = {
        companyId: this.companyId,
        oldSpecification: this.dataForm2.specification || undefined,
        oldGoodsName: this.dataForm2.goodsName || undefined,
        oldGoodsCode: this.dataForm2.custGoodsCode || undefined,
        oldModel: this.dataForm2.model || undefined
      }
      this.$http
        .post(`/front/order/lclb/receive/getSparePartsDetailByOrdinary`, params)
        .then(({ data: res }) => {
          this.goodsList = res.data
          this.dataListLoading = false
          const custspIds = this.detailInfo.receiveDetailList.map(
            (item) => item.custspId
          )
          setTimeout(() => {
            this.goodsList.forEach((item) => {
              if (custspIds.includes(item.custspId)) {
                this.$refs.multipleTable.toggleRowSelection(item, true)
              } else {
                this.$refs.multipleTable.toggleRowSelection(item, false)
              }
            })
          }, 100)
        })
    },
    // 关闭物料信息弹窗
    cancelGoods () {
      this.searchVisible = false
    },
    // 重置物料信息
    handleReset () {
      this.dataForm2 = {
        custGoodsCode: '',
        model: '',
        specification: '',
        goodsName: ''
      }
      this.handleCode()
    },
    // 选中物料
    confirmPush (arr) {
      var newList = []
      // var flag = true
      if (arr) {
        arr.forEach((item) => {
          const {
            oldGoodsCode,
            oldGoodsName,
            oldSpecification,
            oldModel,
            oldRemark,
            safetyStockQuantity,
            custspId,
            oldConfiguration,
            oldEdition,
            brand,
            price,
            physicalUnitAmount,
            sellingUnitStepSize,
            moq,
            skuId
          } = item
          newList.push({
            oldGoodsCode,
            oldGoodsName,
            oldSpecification,
            oldModel,
            oldRemark,
            safetyStockQuantity,
            custspId,
            oldConfiguration,
            oldEdition,
            brandName: brand,
            goodsPrice: price,
            physicalUnitAmount,
            sellingUnitStepSize,
            moq,
            skuId
          })
        })
        // 先获取已存在的
        const custspIds = this.detailInfo.receiveDetailList.map(
          (item) => item.custspId
        )
        let dataList = [...this.detailInfo.receiveDetailList]
        dataList = dataList.filter(
          (item) => item.custspId || item.oldGoodsCode
        )
        newList.forEach((item) => {
          // 不存在的再添加进行
          if (!custspIds.includes(item.custspId)) {
            dataList.push(item)
          }
        })
        this.detailInfo.receiveDetailList = dataList
      }
      this.searchVisible = false
    },
    // 多选
    selectionChangeHandle (val) {
      this.dataListSelections = val
    },
    // 双击多选
    handledbClick (row, event, column) {
      // console.log(row.index, event, column)
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    // 选中物料信息
    checkSelectable (row) {
      let res = this.detailInfo.receiveDetailList.some((item) => {
        if (item.custspId === row.custspId) {
          return true
        }
        return false
      })
      return !res
    },
    // 备件选择弹窗关闭
    produceDialogClose () {
      this.$refs.dataForm2.resetFields()
    },
    // 导入成功
    fileSuccess (response, file, fileList) {
      // console.log(response)
      if (response.data && response.code === 0) {
        this.$message.success(response.message)
        let list = response.data || []
        list.forEach((item) => {
          item.goodsNum = item.receiveQuantity
          item.goodsPrice = item.price
        })
        this.detailInfo.receiveDetailList.forEach((item) => {
          for (let i = 0; i < list.length; i++) {
            if (list[i].oldGoodsCode === item.oldGoodsCode) {
              item.goodsNum = Number(item.goodsNum) + Number(list[i].goodsNum)
              item.goodsNum += ''
              list.splice(i, 1)
            }
          }
        })
        // console.log(list)
        var totalList = [...this.detailInfo.receiveDetailList, ...list]
        this.detailInfo.receiveDetailList = totalList
      } else {
        this.errorContent = response.message
        this.importVisible = true
      }
    },
    // 导入失败
    fileError (file, fileList) {
      this.$message.error('导入失败，请重新上传')
    },
    setDataList (arr = []) {
      console.log('setDataList', arr)
      arr.forEach((item) => {
        this.detailInfo.receiveDetailList.push({
          oldGoodsCode: item.oldGoodsCode,
          oldGoodsName: item.oldGoodsName,
          oldSpecification: item.oldSpecification,
          oldModel: item.oldModel,
          oldRemark: item.oldRemark,
          goodsNum: item.goodsNum || item.safetyStockQuantity,
          oldEdition: item.oldEdition,
          oldConfiguration: item.oldConfiguration,
          safetyStockQuantity: item.safetyStockQuantity,
          goodsPrice: item.price,
          brandName: item.brandName,
          custspId: item.custspId || null,
          physicalUnitAmount: item.physicalUnitAmount || '',
          sellingUnitStepSize: item.sellingUnitStepSize || '',
          moq: item.moq || '',
          skuId: item.goodsSkuId || ''
        })
      })
    },
    getUserInfo () {
      return this.$http
        .get('/front/consumer/usercenter/custUserCenterInfo', {
          params: {
            appCode: 'PLANTMATE_OFFICIAL',
            companyId: this.companyId
          }
        })
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.userInfo = res.data.userInfo
        })
        .catch(() => {})
    },
    // 备件信息上传
    importInfo () {
      // this.$refs.inputer.click()
      this.$refs.fielUplod.$el.childNodes[0].childNodes[1].click()
    },
    // 导出失败
    handleExportFailed () {
      this.exportVisible = true
      this.importVisible = false
      this.errorContent = ''
      this.handleExportSearch(1)
    },
    handleExportSearch (currentPage = this.currentPage) {
      this.currentPage = currentPage
      let params = {
        companyId: this.companyId,
        page: currentPage,
        limit: 10
      }
      this.$http
        .post(`/front/order/lclb/receive/failListByOrdinary`, params)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.dataFailedList = res.data.data
            this.total = res.data.count
          } else {
            this.dataFailedList = []
            this.total = 0
          }
        })
    },
    cancelFail () {
      this.exportVisible = false
    },
    // 导出失败记录
    handleFailExport () {
      axios({
        method: 'post',
        headers: {
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + getAccessToken()
        },
        responseType: 'blob', // 一定要写
        url: `${window.SITE_CONFIG['apiURL']}/front/order/lclb/receive/failExport`,
        data: {
          companyId: this.companyId
        }
      })
        .then((res) => {
          if (res.data.size > 0) {
            const reader = new FileReader()
            reader.onload = (e) => {
              const blob = new Blob([res.data], {
                type: 'application/vnd.ms-excel'
              })
              const date = new Date()
              const month = date.getMonth() + 1
              const day = date.getDate()
              const fileName =
                '失败记录列表' +
                date.getFullYear() +
                (month >= 10 ? month : '0' + month) +
                (day >= 10 ? day : '0' + day) // 下载的文件名
              if ('msSaveOrOpenBlob' in navigator) {
                // 'IE'
                window.navigator.msSaveOrOpenBlob(blob, fileName + '.xls')
              } else {
                const link = document.createElement('a')
                link.style.display = 'none'
                link.href = URL.createObjectURL(blob)
                link.download = res.headers['content-disposition'] // 下载后文件名
                link.download = fileName
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
              }
            }
            reader.readAsText(res.data)
          }
        })
        .catch(() => {})
    },
    // 分页查询导出信息
    handleSizeChange (val) {
      this.handleExportSearch(1)
    },
    handleCurrentChange (val) {
      this.currentPage = val
      // console.log(val)
      this.handleExportSearch()
    },
    // 填写领用原因
    handleSaveReason () {
      this.visible = false
    },
    // 关闭领用弹窗
    cancelAdd () {
      this.visible = false
      this.detailInfo.excessMemo = ''
    },
    // 确认修改
    handleSave () {
      if (this.subLoading) {
        return false
      }
      if (this.oweFeeFlag === 1) {
        this.$message.error(this.$t('message.pleasePay'))
        return
      }
      if (
        this.detailInfo.expectDeliveryDate === '' ||
        this.detailInfo.expectDeliveryDate === null
      ) {
        this.$message.error(this.$t('message.emptyDate'))
      }
      // 表单校验
      let flagValidate = true
      this.$refs.detailInfoform.validate((valid) => {
        if (!valid) {
          flagValidate = false
        }
      })
      // 领用原因
      let flag = true
      this.detailInfo.receiveDetailList.forEach((item, index) => {
        if (!this.detailInfo.excessMemo) {
          // 超量原因为空
          if (
            item.safetyStockQuantity &&
            item.goodsNum > item.safetyStockQuantity
          ) {
            this.visible = true
            flag = false
          }
        }
      })
      if (flag && flagValidate) {
        this.subLoading = true
        console.log(this.detailInfo)
        if (
          this.detailInfo.payOrderInvoiceVo &&
          this.detailInfo.payOrderInvoiceVo.orderInvoiceId
        ) {
          this.detailInfo.orderInvoiceRefactoryForm =
            this.detailInfo.payOrderInvoiceVo || {}
          this.detailInfo.orderInvoiceRefactoryForm.orderId =
            this.detailInfo.orderId
        }
        this.detailInfo.orderAddressRefactoryForm =
          this.detailInfo.addressVo || {}

        this.detailInfo.orderAddressRefactoryForm.orderId =
          this.detailInfo.orderId
        // delete this.detailInfo.addressVo
        // delete this.detailInfo.payOrderInvoiceVo
        this.detailInfo.companyId = this.companyId

        const checkObj = {
          companyId: this.companyId,
          orderItemList: this.detailInfo.receiveDetailList.map((i) => {
            return {
              goodsNum: i.goodsNum,
              goodsSkuId: i.skuId || i.goodsSkuId,
              oldGoodsCode: i.oldGoodsCode
            }
          })
        }

        this.$http
          .post(`/front/consumer/order/checkFrontOrderItem`, checkObj)
          .then(({ data: { code, data } }) => {
            if (code === 0) {
              // 校验成功
              if (!(data || []).length) {
                this.submit()
              } else {
                // 校验失败
                this.$refs.errorTip.onShow(
                  data,
                  this.$store.state.user.company.companyName
                )
                this.subLoading = false
              }
            } else {
              this.subLoading = false
            }
          })
      }
    },
    submit () {
      this.$http
        .post(`/front/order/lclb/receive/updateByOrdinary`, this.detailInfo)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.$message.success(this.$t('message.updateSuccess'))
            this.subLoading = false
            this.$router.push({ name: 'spareGetList' })
          } else {
            this.subLoading = false
          }
        })
        .catch(() => {
          this.subLoading = false
        })
    },
    // 初始化页面信息
    getInfo () {
      this.payInvoiceInfoList = []
      this.$http
        .get(`/front/order/lclb/receive/info/${this.$route.query.id}`)
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.detailInfo = res.data

            this.orderFileList = (res.data.attachmentList || []).map((i) => ({
              ...i,
              fileUrl: i.url,
              name: i.fileName
            }))
            this.detailInfo.attachmentList = (
              res.data.attachmentList || []
            ).map((i) => i.aliOssId)
            this.detailInfo.expectDeliveryDate = res.data.expectDeliveryDate
              ? res.data.expectDeliveryDate.slice(0, 10)
              : null
            if (res.data.payOrderInvoiceVo) {
              this.detailInfo.orderInvoiceId = res.data.orderInvoiceId || ''
            } else {
              this.detailInfo.orderInvoiceId = ''
            }
            this.detailInfo.applyTime = fomatDateTime(res.data.applyTime)
            this.addressId = res.data.addressId
          } else {
            this.detailInfo.receiveDetailList = []
          }
        })
    }
  },
  mounted () {
    this.upLoadUrl =
      window.SITE_CONFIG['apiURL'] +
      `/front/order/lclb/receive/importRByOrdinary?companyId=` +
      this.companyId
    this.getUserInfo()
    this.getInfo()
    if (this.$route.query.getList && this.$route.query.getList === 1) {
      this.setDataList(this.$store.state.lclbDataList)
    }
  }
}
</script>
<style lang="scss">
.spare_add_page .page_detail {
  background: #fff;
  padding: 30px;
  width: 1190px;
  margin: 0 auto;
  .box_distance {
    margin-top: 20px;
  }
  .el-step__line {
    position: absolute;
    left: 60%;
    width: 80%;
  }
  .addBtn-box {
    font-size: 14px;
    height: 20px;
    line-height: 20px;
    color: #3d88d4;
    float: right;
    cursor: pointer;
    img {
      width: 16px;
      height: 16px;
      display: block;
      float: left;
      margin: 2px 6px;
    }
  }
  .goodsCode {
    position: relative;
  }
  .total_info {
    position: relative;
    height: 80px;
    background-color: #eeeeee;
    .total_produce {
      width: 100%;
      height: 20px;
      overflow-wrap: break-word;
      color: rgba(51, 51, 51, 1);
      font-size: 14px;
      font-family: PingFangSC-Regular;
      white-space: nowrap;
      line-height: 20px;
      text-align: right;
      align-self: flex-end;
    }
    .total_price {
      font-size: 14px;
      font-family: PingFangSC-Regular;
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
      text-align: right;
      overflow: hidden;
      text-overflow: ellipsis;
      .price {
        font-size: 16px;
        font-family: PingFangSC-Medium;
        color: rgba(255, 54, 54, 1);
      }
    }
    .submit_btn {
      position: absolute;
      display: inline-block;
      right: 0;
      width: 182px;
      cursor: pointer;
      background-color: #ff3636;
      font-size: 18px;
      line-height: 80px;
      color: #fff;
      text-align: center;
    }
  }
  >>> .bill-box .ad-btnBox {
    width: 170px;
  }
}
.my-kqoption-spareGetAdd {
  width: auto !important;
  max-width: 300px;
}
.addFunc {
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.produce_dialog {
  .addCancel {
    width: 158px;
    height: 48px;
    line-height: 48px;
    text-align: center;
    color: #3d88d4;
    border: 1px solid #3d88d4;
    margin-right: 10px;
    user-select: none;
    cursor: pointer;
  }
  .addConfirm {
    background-color: #3d88d4;
    color: #fff;
  }
}
</style>
